//* IMP: This componet acts as a wrapper for the dynamic filed side pane.

// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";

// Component Imports
import DynamicFieldInfo from "./DynamicFieldInfo";
import DynamicFieldList from "./DynamicFieldList";
import DynamicFieldSelect from "./DynamicFieldSelect";
import CustomDynamicFieldSelect from "./CustomDynamicFieldSelect";

// Actions Imports
import { DocumentTemplateActions } from "../../../actions";

// Destructuring
const { toggleDynamicFieldView } = DocumentTemplateActions;

class DynamicField extends Component {
  _decideView = () => {
    const { view, isLocked } = this.props;
    let formView = view;
    if (formView !== "SELECT" && formView !== "CUSTOM" && view !== "INFO") {
      formView = this.props.isDynamicFieldApplied ? "LIST" : "INFO";
    }
    switch (formView) {
      case "INFO":
        return <DynamicFieldInfo />;
      case "LIST":
        return <DynamicFieldList isLocked={isLocked} />;
      case "SELECT":
        return (
          <DynamicFieldSelect
            isDynamicFieldApplied={this.props.isDynamicFieldApplied}
          />
        );
      case "CUSTOM":
        return <CustomDynamicFieldSelect />;
      default:
        return <DynamicFieldInfo />;
    }
  };

  render() {
    return this._decideView();
  }
}

const mapStateToProps = state => {
  const {
    dynamicFields: { view },
    template: { fields_used: fieldsUsed },
  } = state.TemplateStore;

  // Passes a Boolean flag
  const isDynamicFieldApplied =
    Array.isArray(fieldsUsed) && fieldsUsed.length > 0;

  return { view, isDynamicFieldApplied };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DynamicField);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicField.js